import { styled } from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";
//Types
import { ButtonProps } from "./button.types";

export const CustomButton = styled(LoadingButton)<ButtonProps>(
  ({
    theme,
    minwidth,
    width,
    margin,
    align,
    textdecorationline,
    height,
    fontSize,
    fontWeight,
    boxshadow,
    color,
  }) => ({
    textTransform: "none",
    width: width,
    minWidth: minwidth,
    alignSelf: align,
    textDecorationLine: textdecorationline,
    height: height,
    fontSize: fontSize,
    fontWeight: fontWeight,
    margin,
    borderRadius: "opx",
    color:"#202546",
    clipPath: "polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 20px 100%, 0 calc(100% - 20px))",
    backgroundColor: "#F7C338",
    border:"none",
    boxShadow: "none",
    ":hover": {
      boxShadow: boxshadow,
      color: color,
      backgroundColor: "#F7C338",
      border:"1px solid #F7C338",
    },
    
  })
);